import { useGetIdentity } from 'react-admin';

import { PutBoExternalTutorialDoneEndpoint } from '@Common/types/bo_external/admins';

import { useUpdatePromise } from '@sh4res/bo-common/hooks';

export const useSetTutorialDone = () => {
  const [update] = useUpdatePromise<PutBoExternalTutorialDoneEndpoint['Client']['RequestBody']>();
  const { data: identity } = useGetIdentity();

  return () => {
    if (!identity) {
      return;
    }
    update('admins/tutorial_done', {
      id: identity.id,
      data: { is_tutorial_done: true },
    });
  };
};
